<template>
  <modal v-if="showInvite" @close="$emit('cancel')">
    <h2 slot="header">Invite {{ roleTitle }}</h2>
    <div slot="body">
      <!-- Displaying User Name and Email -->
      <label>User Name: {{ profileData.first_name + " " + profileData.last_name }}</label>
      <label>User Email: {{ profileData.email }}</label>
      <br/><br/>
      
      <!-- Invite to Offering or Document Flow -->
      <label>Invite to:</label>
      <div class="radio radio-primary">
        <input type="radio" name="Invite_to" class="radio-primary" value="offering" v-model="inviteTo" @change="isVisible"/>
        <label>Offering</label>
      </div>

      <!-- Showing Offering Dropdown if 'Offering' is selected -->
      <div v-if="inviteTo === 'offering'" class="form-group">
        <label for="investor_offering">Select an Offering</label>
        
        <div v-if="loadingOfferings" class="text-center">
          <i class="fa fa-spinner fa-spin"></i> Loading offerings...
        </div>
        
        <select
          v-else
          id="investor_offering"
          class="form-control"
          name="investor_offering"
          v-model="payload.offering_id"
          required
        >
          <option disabled="disabled" value="">--Select an Offering--</option>
          <option v-for="option in offeringList" :value="option.id" :key="option.id">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>
    <div slot="footer">
      <!-- Cancel Button -->
      <button
        class="modal-default-button btn btn-default margin-left-10"
        type="button"
        @click="cancel"
      >
        Cancel
      </button>
      
      <!-- Invite Button -->
      <button
        class="modal-default-button btn btn-primary"
        type="button"
        @click="inviteInvestor"
        :disabled="loadingOfferings"
      >
        {{ okButtonName }}
      </button>

      <!-- Response Message -->
      <label v-if="showResMessage">{{ resMessage }}</label>
    </div>
  </modal>
</template>

<script>
import Modal from '../Modal.vue'
import axios from "axios";

export default {
  name: "InviteInvestorModal",
  components: {
    Modal,
  },
  props: {
    showInvite: Boolean,
    profileData: Object,
    roleTitle: {
      type: String,
      default: "Dealing Rep"
    },
    roleId: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      offeringList: [], // Moved from prop to data
      loadingOfferings: false,
      payload: {
        investor_id: 0,
        offering_id: 0,
        doc_flow_id: 0,
        investor_amount: '',
        role_id: 0
      },
      resMessage: '',
      showResMessage: false,
      inviteTo: 'offering',
      okButtonName: 'Invite',
    }
  },
  watch: {
    // Load offerings when modal opens
    showInvite(newVal) {
      if (newVal && this.offeringList.length === 0) {
        this.loadOfferings()
      }
    }
  },
  methods: {
    async loadOfferings() {
      this.loadingOfferings = true
      try {
        // Extract EMD slug from current URL path
        const pathParts = window.location.pathname.split('/')
        const emdSlug = pathParts[2] // /admin/{slug}/team
        
        const response = await axios.get(`/admin/${emdSlug}/api/offerings`)
        this.offeringList = response.data
      } catch (error) {
        console.error('Failed to load offerings:', error)
        this.offeringList = []
        // Optionally show error message
        this.resMessage = 'Failed to load offerings. Please try again.'
        this.showResMessage = true
      } finally {
        this.loadingOfferings = false
      }
    },
    
    inviteInvestor() {
      this.payload.investor_id = this.profileData.id;
      this.payload.role_id = this.roleId;
      if (this.inviteTo === 'offering') {
        this.inviteToOffering();
      } 
    },
    inviteToOffering() {
      if (!this.payload.offering_id) {
        alert('Please select an offering');
        return;
      }

      this.payload.role_id = this.roleId;
      
      axios.post('investor/invite', this.payload)
        .then(response => {
          this.resMessage = response.data.statusMessage;
          this.showResMessage = true;
          if (response.data.status === 'error') {
            return;
          }
          this.timer();
        });
    },
    inviteToDocumentFlow() {
      axios.post('investor/flow_invite', this.payload)
        .then(response => {
          this.resMessage = response.data.statusMessage;
          this.showResMessage = true;
          if (response.data.status === 'error') {
            return;
          }
          this.timer();
        });
    },
    cancel() {
      this.showResMessage = false;
      this.resMessage = '';
      this.payload = {};
      this.$emit('cancel');
    },
    timer() {
      setTimeout(() => {
        this.showResMessage = false;
        this.resMessage = '';
        this.$emit('ok');
      }, 3000);
    },
    isVisible() {
      // Logic to toggle visibility can go here if needed
    },
  },
  created() {
    this.inviteTo = 'offering';
  }
}
</script>
